export enum ExemptionKind {
  ASSESSMENT_NOT_ALL_USERS_SIGNED_ON = 'AssessmentNotAllUsersSignedOn',
  ASSESSMENT_REVIEWED = 'AssessmentReviewed',
  EVIDENCE_RECIEVED = 'EvidenceReceived',
  JOB_BLOCKER_RECEIVED = 'JobBlockerReceived',
  TEXT_RECIEVED = 'TextReceived',
  FORM_RECEIVED = 'FormReceived',
  PERMIT_RECEIVED = 'PermitReceived',
}
